import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { fetchingAPI } from '@/api/fetchingAPI'
import { apiService } from '@/api/apiService'
import { appendSessions, setSessions } from '@/reducers/kodi/kodi.redux'

import { KODI_SESSIONS_PAGE_SIZE } from '../kodi.constants'

export const useKodiSessions = ({ enabled }) => {
  const dispatch = useDispatch()
  const { token } = useSelector((state) => state.currentUser)
  const sessions = useSelector((state) => state.kodi.sessions)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const [hasMore, setHasMore] = useState(false)
  // Track server-confirmed count separately so optimistic synthetic rows
  // (added via prependSession) don't inflate the pagination offset.
  const [serverCount, setServerCount] = useState(0)

  useEffect(() => {
    if (!enabled || !token) {
      return undefined
    }
    let cancelled = false
    setLoading(true)
    setError(null)
    fetchingAPI(`${apiService.kodi}/sessions`, 'GET', dispatch)
      .then((rows) => {
        if (cancelled) {
          return
        }
        const list = Array.isArray(rows) ? rows : []
        dispatch(setSessions(list))
        setServerCount(list.length)
        setHasMore(list.length === KODI_SESSIONS_PAGE_SIZE)
      })
      .catch((fetchError) => {
        if (!cancelled) {
          setError(fetchError)
        }
      })
      .finally(() => {
        if (!cancelled) {
          setLoading(false)
        }
      })
    return () => {
      cancelled = true
    }
  }, [enabled, token, dispatch])

  const loadMore = () => {
    if (loading || !hasMore) {
      return
    }
    setLoading(true)
    fetchingAPI(`${apiService.kodi}/sessions?offset=${serverCount}`, 'GET', dispatch)
      .then((rows) => {
        const list = Array.isArray(rows) ? rows : []
        dispatch(appendSessions(list))
        setServerCount((prior) => prior + list.length)
        setHasMore(list.length === KODI_SESSIONS_PAGE_SIZE)
      })
      .catch((fetchError) => {
        setError(fetchError)
      })
      .finally(() => {
        setLoading(false)
      })
  }

  return { sessions, loading, error, hasMore, loadMore }
}
